import type { AxiosResponse } from 'axios';
import { api } from './index'

export interface TopDonorsItem {
  userName: string;
  profileImage: string;
  timeWindowDonatedSeed: number;
  position: number;
}

export type TopDonorsTimeWindow = 'day' | 'week';

export async function fetchTopDonorsItems(
  timeWindow: TopDonorsTimeWindow
): Promise<TopDonorsItem[]> {
  let res: AxiosResponse<{ topDonors: TopDonorsItem[] }>;

  try {
    res = await api.get('/v2/feed/top-donors', { params: { timeWindow } });
  } catch (err) {
    return [];
  }

  return res?.data?.topDonors;
}
